import x from "../../@babel/runtime/helpers/esm/extends.mjs";
import A from "../../@babel/runtime/helpers/esm/defineProperty.mjs";
import Y from "../../@babel/runtime/helpers/esm/objectSpread2.mjs";
import L from "../../@babel/runtime/helpers/esm/objectWithoutProperties.mjs";
import V from "../../@rc-component/trigger/es/index.mjs";
import X from "../../classnames/index.mjs";
import * as e from "react";
var k = ["prefixCls", "disabled", "visible", "children", "popupElement", "containerWidth", "animation", "transitionName", "dropdownStyle", "dropdownClassName", "direction", "placement", "builtinPlacements", "dropdownMatchSelectWidth", "dropdownRender", "dropdownAlign", "getPopupContainer", "empty", "getTriggerDOMNode", "onPopupVisibleChange", "onPopupMouseEnter"], D = function(t) {
  var o = t === !0 ? 0 : 1;
  return {
    bottomLeft: {
      points: ["tl", "bl"],
      offset: [0, 4],
      overflow: {
        adjustX: o,
        adjustY: 1
      },
      htmlRegion: "scroll"
    },
    bottomRight: {
      points: ["tr", "br"],
      offset: [0, 4],
      overflow: {
        adjustX: o,
        adjustY: 1
      },
      htmlRegion: "scroll"
    },
    topLeft: {
      points: ["bl", "tl"],
      offset: [0, -4],
      overflow: {
        adjustX: o,
        adjustY: 1
      },
      htmlRegion: "scroll"
    },
    topRight: {
      points: ["br", "tr"],
      offset: [0, -4],
      overflow: {
        adjustX: o,
        adjustY: 1
      },
      htmlRegion: "scroll"
    }
  };
}, O = function(t, o) {
  var g = t.prefixCls;
  t.disabled;
  var h = t.visible, b = t.children, l = t.popupElement, a = t.containerWidth, d = t.animation, w = t.transitionName, v = t.dropdownStyle, P = t.dropdownClassName, s = t.direction, C = s === void 0 ? "ltr" : s, R = t.placement, u = t.builtinPlacements, n = t.dropdownMatchSelectWidth, m = t.dropdownRender, N = t.dropdownAlign, M = t.getPopupContainer, j = t.empty, y = t.getTriggerDOMNode, r = t.onPopupVisibleChange, E = t.onPopupMouseEnter, S = L(t, k), i = "".concat(g, "-dropdown"), c = l;
  m && (c = m(l));
  var T = e.useMemo(function() {
    return u || D(n);
  }, [u, n]), W = d ? "".concat(i, "-").concat(d) : w, f = e.useRef(null);
  e.useImperativeHandle(o, function() {
    return {
      getPopupElement: function() {
        return f.current;
      }
    };
  });
  var p = Y({
    minWidth: a
  }, v);
  return typeof n == "number" ? p.width = n : n && (p.width = a), /* @__PURE__ */ e.createElement(V, x({}, S, {
    showAction: r ? ["click"] : [],
    hideAction: r ? ["click"] : [],
    popupPlacement: R || (C === "rtl" ? "bottomRight" : "bottomLeft"),
    builtinPlacements: T,
    prefixCls: i,
    popupTransitionName: W,
    popup: /* @__PURE__ */ e.createElement("div", {
      ref: f,
      onMouseEnter: E
    }, c),
    popupAlign: N,
    popupVisible: h,
    getPopupContainer: M,
    popupClassName: X(P, A({}, "".concat(i, "-empty"), j)),
    popupStyle: p,
    getTriggerDOMNode: y,
    onPopupVisibleChange: r
  }), b);
}, I = /* @__PURE__ */ e.forwardRef(O);
I.displayName = "SelectTrigger";
export {
  I as default
};
//# sourceMappingURL=SelectTrigger.mjs.map
